import React from 'react';
import PropTypes from 'prop-types';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';

const ImageOkOrNot = ({checked = false, ...rest}) => {
  const iconPath = checked
    ? '/media/svg/Check.svg'
    : '/media/svg/Cross.svg';
  const altText = checked ? 'yes' : 'no';
  return (
    <img
      src={toAbsoluteUrl(iconPath)}
      alt={altText}
      {...rest}
    />
  );
};

ImageOkOrNot.propTypes = {
  checked: PropTypes.bool,
};

export default ImageOkOrNot;
